import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const dropdownItems = {
  COUNTRY: [
    "SOUTH AFRICA", "Botswana", "Cameroon", "Congo Democratic Republic (DRC)",
    "Cote-divorie", "Eswatini (Swaziland)", "Ethiopia", "Ghana", "Kenya",
    "Lesotho", "Malawi", "Mozambique", "Namibia", "Nigeria", "Rwanda",
    "Senegal", "Sierra Leone", "Somalia", "South Africa", "South Sudan",
    "Tanzania", "Uganda", "Zambia", "Zimbabwe",
  ],
REGION: [
  { name: "Eastern Cape", value: 1200 },
  { name: "Free State", value: 1900 },
  { name: "Gauteng", value: 1100 },
  { name: "KwaZulu-Natal", value: 1600 },
  { name: "Limpopo", value: 1300 },
  { name: "Mpumalanga", value: 1700 },
  { name: "Northern Cape", value: 1800 },
  { name: "North West", value: 1500 },
  { name: "Western Cape", value: 1400 },
],

  MUNICIPALITY: [
    { name: "Johannesburg", value: "110101" },
    { name: "City of Tshwane", value: "110101" },
    { name: "Ekurhuleni", value: "160101" },
    { name: "Cape Town", value: "140101" },
    { name: "eThekwini", value: "" },
    { name: "Nelson Mandela Bay", value: "120101" },
    { name: "Buffalo City", value: "" },
    { name: "Mangaung", value: "" },
    { name: "Vhembe", value: "" },
    { name: "Cape Winelands", value: "" },
    { name: "uMgungundlovu", value: "" },
    { name: "Stellenbosch", value: "" },
    { name: "Thulamela Local", value: "" },
    { name: "Msunduzi Local", value: "" },
    { name: "Govan Mbeki", value: "" }
  ],
  TYPE: [
    "Learners",
    "Moderator",
    "SETA Staff",
    "Facilitators",
    "Training providers",
    "Assessors",
    "Moderators",
    "EIA",
  ],
  "VALUE CHAIN": [
    "Maize","Macadamia", "Nuts", "Avocados", "Fruits", "Sugar cane", "Potatoes", "Tomatoes", "Onions", "Meat", "Poultry", "Dairy", "Fish", "Bees", "Timber", "Clothing", "Textile", "Footwear", "Leather", "Construction", "Solar", "Wind", "Tourism", "ICT Services", "Waste Management", "Logistics", "Music", "Film", "Fashion", "Gaming"
  ],
  PROJECT: [
  "Abattoir (P)", "Abattoir (C)", "Abattoir (S)", "Abattoir (G)", "Citrus", "Sugarcane"

  ],
};

// Controlled dropdown component
const Dropdown = ({
  label,
  items,
  type,
  value,
  onChange,
  isProjectDropdown,
  index // <-- new prop
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  // Check if the label is REGION or MUNICIPALITY
  const hideCheckmarkAndIcon = label === "REGION" || label === "MUNICIPALITY";

  return (
    <div className="flex flex-col w-full md:mt-0 mt-1 relative md:mb-3">
      {/* Label */}
      <label className="md:text-[20px] font-bold text-[5px] text-black mb-1 capitalize truncate">
        {label}
      </label>

      {/* Button + Icon Container */}
      <div className="flex relative z-20 w-full">
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className={`relative xl:w-[168px] lg:w-[140px] md:w-[100px] w-full h-[20px] md:h-[53px] ${
            isProjectDropdown ? "bg-[#152C24]" : "bg-[#03897B]"
          } text-white flex justify-center items-center text-[4px] md:text-[17px] px-[2px] rounded-l-[4px]`}
        >
          {value}

          {/* Bottom-right tag only for first three dropdowns */}
          {index <= 2 && (
            <span className="absolute bottom-0 right-2 text-[4px] md:text-[12px] font-normal">
              {index === 0
                ? "+27"
                : index === 1
                ? "1100"
                : "110101"}
            </span>
          )}
        </button>

        <div
          onClick={() => setIsOpen((prev) => !prev)}
          className={`w-[16px] md:w-[37px] h-[20px] md:h-[53px] ${
            isProjectDropdown ? "bg-[#F38323]" : "bg-[#152C24]"
          } flex justify-center items-center rounded-r-[4px] -ml-1 z-30 cursor-pointer`}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-2 h-2 md:w-5 md:h-[24px]"
          />
        </div>
      </div>

      {/* Dropdown Items */}
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 md:py-5 left-0 z-50 w-full md:w-[190px] border border-[#979797]/80 bg-white rounded shadow-lg p-1 md:p-2"
          >
            <li className="flex items-center justify-between text-[4px] md:px-3 px-1 md:text-[16px] font-semibold mb-2">
              {label}
              {!hideCheckmarkAndIcon && (
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                  alt="icon"
                  className="w-[7px] h-[7px] md:w-[25px] md:h-[25px]"
                />
              )}
            </li>
            {items.map((item, index) => (
  <div
    key={index}
    onClick={(e) => {
      e.preventDefault(); // Prevent default behavior
      e.stopPropagation(); // Stop event propagation
      setIsOpen(false);
      onChange(type, typeof item === "object" ? item.name : item); // Pass item.name for objects
    }}
    className="flex justify-between items-center px-1 md:px-3 py-1 md:py-2 rounded-md hover:underline cursor-pointer"
  >
    {type === "REGION" && typeof item === "object" ? (
      <div className="text-black text-[4px] md:text-[14px] flex-1 text-right w-full">
        <div className="md:pr-2">{item.name}</div>
        <div className="text-gray-500 text-[3px] md:text-[12px]">{item.value}</div>
      </div>
    ) : type === "MUNICIPALITY" && typeof item === "object" ? (
      // Handling MUNICIPALITY object items
      <div className="text-black text-[4px] md:text-[14px] flex flex-col text-left w-full">
        <div>{item.name}</div>
        <div className="text-gray-500 text-[3px] md:text-[12px]">{item.value}</div>
      </div>
    ) : (
      <span className="text-black text-[4px] md:text-[14px]">
        {item}
      </span>
    )}

    {!hideCheckmarkAndIcon && (
      <div
        className={`w-2 h-2 md:w-4 md:h-4 rounded-full ${
          value === (typeof item === "object" ? item.name : item) ? "bg-[#03897B]" : "bg-gray-200"
        }`}
      ></div>
    )}
  </div>
))}




          </motion.ul>
        )}
      </AnimatePresence>

      {/* Hint */}
      <p className="text-[4px] md:text-[14px] mt-[2px] lowercase text-black truncate">
        {isProjectDropdown
          ? "Select View More"
          : `Select ${type === "TYPE" ? "type of entrepreneur" : label}`}
      </p>
    </div>
  );
};


// ReportsSection takes the values and handler from parent (registration page)
const ReportsSection = ({ values, onChange }) => {
  const keys = Object.keys(dropdownItems);

  return (
    <div className="w-full md:mb-10  md:mt-10 mt-5 mb-3 font-Inter mx-auto px-1">
      <div className="flex md:flex-unwrap flex-nowrap gap-[2px] md:gap-[3px] w-full">
        {keys.map((type, index) => {
          const customLabels = {
            Crop: "Crop Report",
            Livestock: "Livestock Report",
            Type: "Type of Report",
          };
          const displayLabel = customLabels[type] || type;
          const isProjectDropdown = index === keys.length - 1;

          return (
            <div
              key={type}
              className="w-[16.6%] min-w-[50px] md:w-auto"
            >
              <Dropdown
                label={displayLabel}
                items={dropdownItems[type]}
                type={type}
                index={index}
                value={values[type]}
                onChange={onChange}
                isProjectDropdown={isProjectDropdown}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportsSection;